var mobileNavInit;

(function ($) {

	const selectors = {
		navContainer: '[data-mobile-menu]',
		trigger: '[data-mobile-menu-trigger]',
	}

	mobileNavInit = function () {
		$(selectors.navContainer).each((i, el) => {
			new MobileNav(el);
		});
	}

	class MobileNav {
		constructor(element) {
			this.$container = $(element);

			this.init();
			this.bind();

		}
		init() {
			this.$trigger = $(selectors.trigger, this.$container);
			this.$dropdownTrigger = $('.c-nav__item-arrow, a[href="#"]', this.$container);
			this.$links = $('a:not([href="#"])', this.$container).not(this.$trigger);

			this.$dropdownTrigger.on('click', this.toggleDropdown.bind(this));

		}

		bind() {
			this.$trigger.click((e) => { this.toggle(); });
			this.$links.click((e) => { this.hide(); });
		}

		toggle() {
			if (this.$container.hasClass('is-active')) {
				this.hide();
			}
			else {
				this.show();
			}
		}

		show() {
			this.$container.addClass('is-active');
		}

		hide() {
			this.$container.removeClass('is-active');
		}

		toggleDropdown(e) {

			const $link = $(e.delegateTarget);

			if ($(window).width() < 900) {
				const $submenu = $link.siblings('.sub-menu');

				if ($submenu.is(":visible")) {
					$submenu.parent().removeClass('has-open');
				}
				else {
					$submenu.parent().addClass('has-open');
				}
				$submenu.stop().slideToggle(200);
			}
		}

	}

})(jQuery);


export default mobileNavInit;